function SensorPage() {
    /**
     *
     */
    SensorPage.prototype.initialize = function (console, sensor) {
        this.id = "sensor";
        this.console = console;
        this.sensor = sensor;

        return this;
    };

    /**
     *
     */
    SensorPage.prototype.show = function () {
        var deferred = $.Deferred();

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    SensorPage.prototype.leave = function () {
    };
}
